(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-trigger"] && !Shopify.designMode) return;
  try {
    // Listen for cart updates and open drawer
  document.addEventListener('DOMContentLoaded', () => {
    // Wait for cart drawer to be available
    const waitForCartDrawer = () => {
      if (window.cartDrawer) {
        setupFormListeners();
      } else {
        setTimeout(waitForCartDrawer, 100);
      }
    };

    const setupFormListeners = () => {
      // Find all forms that are specifically for adding to cart
      // Use a more specific selector to avoid duplicates
      const allCartForms = document.querySelectorAll(
        'form[action*="/cart/add"], form[action*="cart/add"], form[action*="cart_add_url"]'
      );

      allCartForms.forEach((form) => {
        // Prevent duplicate event listeners by checking if already processed
        if (form.dataset.cartListenerAdded) {
          return;
        }
        form.dataset.cartListenerAdded = 'true';

        form.addEventListener('submit', async (e) => {
          e.preventDefault();

          const formData = new FormData(form);
          const submitButton = form.querySelector('[type="submit"]');
          const originalText = submitButton?.textContent;

          // Show loading state
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Adding...';
          }

          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              body: formData,
            });

            if (response.ok) {
              const item = await response.json();

              // Get updated cart
              const cartResponse = await fetch('/cart.js');
              if (cartResponse.ok) {
                const cart = await cartResponse.json();

                // Update cart display
                if (window.cartDrawer) {
                  // Set flag to prevent event dispatch during direct update
                  window.cartDrawer.isUpdatingFromTrigger = true;
                  window.cartDrawer.updateCartDisplay(cart);
                  window.cartDrawer.isUpdatingFromTrigger = false;
                  window.cartDrawer.open();
                } else {
                  console.error('Cart drawer not found, trying to wait for it...');
                  // Try to wait for cart drawer and then open it
                  const waitAndOpen = () => {
                    if (window.cartDrawer) {
                      window.cartDrawer.isUpdatingFromTrigger = true;
                      window.cartDrawer.updateCartDisplay(cart);
                      window.cartDrawer.isUpdatingFromTrigger = false;
                      window.cartDrawer.open();
                    } else {
                      setTimeout(waitAndOpen, 100);
                    }
                  };
                  waitAndOpen();
                }

                // Cart display is already updated by cartDrawer.updateCartDisplay(cart)
                // No need to dispatch additional events to prevent infinite loops
              } else {
                console.error('Error fetching updated cart');
              }
            } else {
              const errorData = await response.json().catch(() => ({}));
              console.error('Error adding to cart:', errorData);

              // Show error message to user
              if (submitButton) {
                submitButton.textContent = 'Error - Try Again';
                setTimeout(() => {
                  if (submitButton) {
                    submitButton.textContent = originalText;
                  }
                }, 2000);
              }
            }
          } catch (error) {
            console.error('Error adding to cart:', error);

            // Show error message to user
            if (submitButton) {
              submitButton.textContent = 'Error - Try Again';
              setTimeout(() => {
                if (submitButton) {
                  submitButton.textContent = originalText;
                }
              }, 2000);
            }
          } finally {
            // Restore button state
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = originalText;
            }
          }
        });
      });
    };

    // Note: Cart updates are now handled by the main cart.js file
    // This prevents duplicate event listeners and infinite recursion

    // Initialize cart button visibility on page load
    const initializeCartButtonVisibility = async () => {
      try {
        const cartResponse = await fetch('/cart.js');
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          const cartButtons = document.querySelectorAll('.cart-drawer-trigger');
          cartButtons.forEach((button) => {
            if (cart.item_count === 0) {
              button.style.display = 'none';
            } else {
              button.style.display = 'inline-flex';
            }
          });
        }
      } catch (error) {
        console.error('Error fetching cart on page load:', error);
      }
    };

    // Initialize cart button visibility
    initializeCartButtonVisibility();

    // Start waiting for cart drawer
    waitForCartDrawer();
  });
  } catch(e) { console.error(e); }
})();

})();
